const i18n = {
	chooseFileError: {
		1 : "Ошибка при выборе файла",
		0 : "Памылка пры выбары файла"
	},
	fileAlreadyChosen: {
		1 : "Файл с таким названием уже был добавлен",
		0 : "Файл з такой назвай ужо быў дададзены"
	},
	deleteFileConfirmationMessage: {
		1 : "Вы уверены? Это действие отменить нельзя.",
		0 : "Вы ўпэўнены? Гэта дзеянне адмяніць нельга."
	},
	maxCountFiles: {
		0 : "Максімальны лік файлаў не павіннен быць больш за 5",
		1 : "Максимальное число файлов не должно превышать 5"
	},
	signer: {
		1 : 'Подписант:\n{0}',
		0 : 'Падпісант:\n{0}'
	},
	maxCountOfAdditionalFiles: {
		0 : "Максімальная колькасць дадатковых файлаў не павінна перавышаць {0}",
		1 : "Максимальное число дополнительных файлов не должно превышать {0}"
	}
}

export default i18n